import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';

import Loadable from 'layouts/full/shared/loadable/Loadable';

/* ****Pages***** */
// Private pages
const ChangePassword = Loadable(lazy(() => import('pages/changepassword')));
const Profile = Loadable(lazy(() => import('pages/profile')));
const BusinessProfile = Loadable(lazy(() => import('pages/profile/business-profile')));
const BrandSettings = Loadable(lazy(() => import('pages/profile/brand-settings')));
const Settings = Loadable(lazy(() => import('pages/settings')));
const CreateWebhook = Loadable(lazy(() => import('pages/settings/create-webhook')));
const MobileVerification = Loadable(
  lazy(() => import('pages/Authentication/mobile-number-verification')),
);
const Disbursement = Loadable(lazy(() => import('pages/disbursement')));
const DisbursementDetail = Loadable(lazy(() => import('pages/disbursement/[id]')));

// Public pages
const VerifyLogin = Loadable(lazy(() => import('pages/Authentication/login-otp-verification')));
const Register = Loadable(lazy(() => import('pages/Authentication/register')));
const RegisterMember = Loadable(lazy(() => import('pages/Authentication/register-member')));
const Login = Loadable(lazy(() => import('pages/Authentication/login')));
const VerificationEmail = Loadable(lazy(() => import('pages/Authentication/verification-email')));
const VerificationEmailCheck = Loadable(
  lazy(() => import('pages/Authentication/verification-email-check')),
);
const ForgotPassword = Loadable(lazy(() => import('pages/Authentication/forgot-password')));
const ResetPassword = Loadable(lazy(() => import('pages/Authentication/reset-password')));
const ResendEmail = Loadable(lazy(() => import('pages/Authentication/resend-email')));
const FourZeroFour = Loadable(lazy(() => import('pages/z-error/404')));

const authProtectedRoutes = [
  { path: '/', element: <Navigate to="/disbursement" /> },
  { path: '/changepassword', element: <ChangePassword /> },
  { path: '/profile', element: <Profile /> },
  { path: '/business-profile', element: <BusinessProfile /> },
  { path: '/settings', element: <BrandSettings /> },
  { path: '/api-settings', element: <Settings /> },
  { path: '/api-settings/create-webhook', element: <CreateWebhook /> },
  { path: '/disbursement', element: <Disbursement /> },
  { path: '/disbursement/:id', element: <DisbursementDetail /> },

  { path: '*', element: <FourZeroFour /> },
];

const publicRoutes = [
  { path: '/register', element: <Register /> },
  { path: '/register-member', element: <RegisterMember /> },
  { path: '/login', element: <Login /> },
  { path: '/login/verify-otp', element: <VerifyLogin /> },
  { path: '/verification-email/:token', element: <VerificationEmail /> },
  { path: '/verification-email-check', element: <VerificationEmailCheck /> },
  { path: '/forgot-password', element: <ForgotPassword /> },
  { path: '/reset-password/:token', element: <ResetPassword /> },
  { path: '/resend-email/:email', element: <ResendEmail /> },
  { path: '/mobile-verification', element: <MobileVerification /> },
  { path: '*', element: <FourZeroFour /> },
];

export { authProtectedRoutes, publicRoutes };
